type Props = {
  text: string;
  maxLength?: number; // Unused, but kept for now, in case we want to bring tooltips back.
};
export const TruncatedText = ({text}: Props) => {
  return <div className="text-wrap line-clamp-1 break-all">{text}</div>;
};
